import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Rect, Group, Image} from 'react-konva';
import {ICardsRenderInfo, RecordState} from '../../redux/types';
import global from '../../global';
import {ICard} from '../../redux/types';

type IProps = {
  card: ICard,
  cardParameters: ICardsRenderInfo,
}

type IRoundedImagProps = {
  image: ImageBitmapSource,
  x: number,
  y: number,
  width: number,
  height: number,
  cornerRadius: number
}

const RoundedImage = ({x, y, width, height, cornerRadius, image}: IRoundedImagProps) => (
  <Group clipFunc={ctx => {
    ctx.beginPath()
    ctx.moveTo(x + cornerRadius, y)
    ctx.lineTo(x + width - cornerRadius, y)
    ctx.quadraticCurveTo(x + width, y, x + width, y + cornerRadius)
    ctx.lineTo(x + width, y + height - cornerRadius)
    ctx.quadraticCurveTo(x + width, y + height, x + width - cornerRadius, y + height)
    ctx.lineTo(x + cornerRadius, y + height)
    ctx.quadraticCurveTo(x, y + height, x, y + height - cornerRadius)
    ctx.lineTo(x, y + cornerRadius)
    ctx.quadraticCurveTo(x, y, x + cornerRadius, y)
    ctx.closePath()
  }}>
    <Image x={x} y={y} width={width} height={height} image={image}/>
  </Group>
)

class Card extends Component<IProps> {
  image: HTMLImageElement;

  constructor(props: IProps) {
    super(props);

    const {card} = props;
    this.image = global.images[card.name];
  }

  render() {
    const {cardParameters, card} = this.props;
    const {width, height, corner} = cardParameters;
    const image = global.images[card.name];

    return (
      <Group>
        <Rect
          width={width}
          height={height}
          stroke={'#cfd8dc'}
          strokeWidth={1}
          cornerRadius={corner}
          hitStrokeWidth={0}
          shadowForStrokeEnabled={false}
          perfectDrawEnabled={false}
        />
        <RoundedImage
          cornerRadius={corner}
          x={0}
          y={0}
          width={width}
          height={height}
          image={image}
        />
      </Group>
    )
  }
}

function mapStateToProps(state: RecordState): { cardParameters: ICardsRenderInfo } {
  return {
    cardParameters: state.get('cardsRenderInfo'),
  }
}

export default connect(mapStateToProps)(Card);